// Functions
import VerifyToken from "../../config/verifyToken";
// Components
import Header from "../../components/header";
import { Main } from "../generalStyle";
import StickyLogo from "../../components/stickyLogo";
import PatientMessages from "../../components/patientMessages";

const PatientMessagesView = () => (
  <>
    {VerifyToken()}
    <Header />
    <Main>
      <StickyLogo />
      <PatientMessages />
    </Main>
  </>
);

export default PatientMessagesView;
